import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import FormArticleInput from 'components/forms/FormArticleInput';
import type { SetEditFormValues } from '../../types';

interface SetFormGeneralProps {
    formData: SetEditFormValues;
    onChange: (patch: Partial<SetEditFormValues>) => void;
    disabled?: boolean;
    isCreate?: boolean;
}

const SetFormGeneral = ({ formData, onChange, disabled = false, isCreate = false }: SetFormGeneralProps) => {
    const { t } = useTranslation(['Sets', 'common']);
    const refInputName = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            refInputName.current?.focus();
        }, 100);
    }, [isCreate]);

    return (
        <>
            <FormArticleInput
                label={t('edit.fields.setArticle')}
                value={formData.setArticle}
                onChange={(setArticle) => onChange({ setArticle })}
                disabled={!isCreate || disabled}
                canGenerate={isCreate && !disabled}
                generateTitle={t('edit.generateArticle')}
                labelClassName="form-label"
            />

            <Form.Group className="mb-3">
                <Form.Label>{t('edit.fields.setName')}</Form.Label>
                <Form.Control
                    ref={refInputName}
                    disabled={disabled}
                    value={formData.setName}
                    onChange={(e) => onChange({ setName: e.target.value })}
                />
            </Form.Group>

            <Form.Group className="mb-0">
                <Form.Label>{t('edit.fields.setDescription')}</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={5}
                    disabled={disabled}
                    value={formData.setDescription}
                    onChange={(e) => onChange({ setDescription: e.target.value })}
                />
            </Form.Group>
        </>
    );
};

export default SetFormGeneral;
